import React from 'react';
import {
  Button,
  Dialog,
  DialogContent,
  Slide,
  createTheme,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/styles';
import Doctor from '../../assets/images/consultant1.png';
import CloseButton from '../../assets/icons/close-circle.svg';
import {ThemeProvider} from 'react-jss';

const useStyles = makeStyles({
  title: {
    fontFamily: 'iranSansX',
    color: '#1D2129',
    fontSize: 18,
    fontWeight: 700,
    marginTop: '10px',
    textAlign: 'center',
  },
  div: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  text: {
    fontFamily: 'iranSansX',
    color: '#4E5969',
    fontSize: '15px',
    lineHeight: '26px',
    letterSpacing: 'large',
    fontWeight: 400,
    textAlign: 'center',
    width: '256px',
    marginTop: '3px',
  },
  button: {
    backgroundColor: '#FF388E',
    color: '#fff',
    borderRadius: '12px',
    marginTop: 8,
    marginBottom: 24,
    fontFamily: 'iranSansX',
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 'large',
    width: '160px',
    height: '48px',
    '&:hover': {
      backgroundColor: '#FF388Ebb',
    },
  },
});

const theme = createTheme();

export default function UserIncreaseModal({
  openAccessModal,
  setOpenAccessModal,
}) {
  const classes = useStyles();
  // const history = useHistory();
  const handleHardReload = () => {
    setOpenAccessModal(false);
  };

  // const isLoginPage = window.location.pathname === '/user/login';

  return (
    <ThemeProvider theme={theme}>
      <div>
        <Dialog
          open={openAccessModal}
          TransitionComponent={Slide}
          TransitionProps={{
            direction: 'up',
            timeout: 800,
          }}
          aria-labelledby="form-dialog-title"
          PaperProps={{
            style: {
              borderRadius: '24px',
              width: 304,
              height: 425,
            },
          }}
        >
          <DialogContent>
            <div style={{position: 'absolute', top: 14, left: 14}}>
              <Button
                style={{
                  minWidth: '20px',
                  padding: 0,
                  margin: 0,
                }}
                onClick={handleHardReload}
              >
                <img
                  src={CloseButton}
                  style={{
                    width: '20px',
                    height: '20px',
                    display: 'block',
                  }}
                  alt="close"
                />
              </Button>
            </div>
            <div className={classes.div}>
              <img src={Doctor} style={{width: '164px', height: '167px'}} />
              <h2 className={classes.title}>
                تراپیست خوب از نون شب <br />
                واجب تره!
              </h2>
              <p className={classes.text}>
                مشاوره روانشناسیتو به تاخیر ننداز، همین الان با یک مشاور دلسوز
                مشورت کن.
              </p>
              <Button
                className={classes.button}
                onClick={() => {
                  window.location.href = '/app/advisers?skill=11&skill=10';
                  setOpenAccessModal(false);
                }}
              >
                مشاهده مشاوران
              </Button>
            </div>
          </DialogContent>
        </Dialog>
      </div>
    </ThemeProvider>
  );
}
